// Legacy WordPress URL: /about-us → /about (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/about-us")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  beforeLoad: () => {
    throw redirect({ to: "/about", statusCode: 301 });
  },
});
